import { render, staticRenderFns } from "./allListActions.vue?vue&type=template&id=21dc1d30"
import script from "./allListActions.vue?vue&type=script&lang=js"
export * from "./allListActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports